import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
export default async function getListOfStore(component) {
  // const Authorization='bearer '+localStorage.getItem('token');

  fetch(`${API_URL}rest/V1/rider/sources`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept,
    },
  })
    .then(function (response) {
      // component.props.getStoreAction(true);
      return response.json();
    })
    .then(function (result) {
      console.log("getStoreAction", result);
      component.props.getStoreAction(result);
    });
}



// WEBPACK FOOTER //
// ./src/utility/api/getAllStore.js